import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import { getDocumentById, uploadDocuments } from "_controllers/officer";
import axios from "axios";
import dotenv from "dotenv";
import { useHistory, useParams } from "react-router-dom";
import { PageHeader, SectionCard } from "_shared/ui";

dotenv.config();

const Main = () => {
  const history = useHistory();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [image, setImage] = useState("");
  const [Values, setValues] = useState({
    documentCategory: "",
    imageUrl: "",
    description: "",
  });
  const [imageLoading, setimageLoading] = useState(false);

  useEffect(async () => {
    const requests = await getDocumentById(id);
    setValues({
      ...Values,
      documentCategory: requests?.doc.documentCategory,
      description: requests?.doc.description,
    });
    setLoading(true);
  }, [message]);

  const { documentCategory, imageUrl, description } = Values;

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit", image);
    let formData = new FormData();
    if (image) {
      if (image.type !== "application/pdf")
        return alert("Upload PDF Files Only.");
      formData.append("file", image);
      formData.append("fileName", image.name);
    }

    formData.append("description", Values.description);
    formData.append("category", Values.documentCategory);
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = process.env.REACT_APP_REQUEST_ENDPOINT;
    await axios
      .put(`${url}/api/v1/document/${id}`, formData, config)
      .then((res) => {
        // setImage("");
        // setMessage(res?.data?.message);
        // console.log("object", res);
        toastMessage(res?.data?.message, "success");
        history.push("/upload-documents");
      })
      .catch((err) => {
        setImage("");
        setMessage(err?.message);
        toastMessage(message, "error");
      });
  };

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value });
  };

  const saveImg = async (e) => {
    setImage(e.target.files[0]);
  };

  console.log("ji", Values);

  return (
    <>
      <PageHeader
        title="Edit Document"
        subtitle="Update the document details and replace the file if needed"
      />

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <SectionCard title="Document Details" sx={{ width: "100%", maxWidth: 820 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2.5}>
              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  value={documentCategory}
                  name="documentCategory"
                  label="Document Type"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  value={description}
                  name="description"
                  label="Description"
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Typography variant="body2" color="text.secondary">
                    Document File (PDF only)
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<UploadFileIcon />}
                    >
                      Choose File
                      <input
                        hidden
                        type="file"
                        name="image"
                        onChange={saveImg}
                      />
                    </Button>
                    {image?.name ? (
                      <Typography variant="body2" color="text.secondary">
                        {image.name}
                      </Typography>
                    ) : null}
                    {imageLoading ? (
                      <CircularProgress size={20} />
                    ) : null}
                  </Box>
                </Stack>
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button type="submit" variant="contained">
                Submit
              </Button>
            </Box>
          </form>
        </SectionCard>
      </Box>
    </>
  );
};

const EditDocument = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default EditDocument;
